import { Box, styled } from "@mui/material";
import { IStyledChatHeaderProps } from "./types";

const StyledHeader = styled(Box)<IStyledChatHeaderProps>(({theme})=>({
    padding: theme.spacing(2),
    backgroundColor: (theme as any).palette.neutral.darkest,
    position: "sticky",
    top: "0px"
}))

export {StyledHeader}